import { defineComponent as _defineComponent } from 'vue'
import { useBasicStore } from '@/stores/basic';
import { storeToRefs } from 'pinia';
import { Message } from 'element-ui';
import {WARNING_MESSAGE,MESSAGE_DURATION} from "@/constants/message";
import { ref, onMounted, onUnmounted, Ref, ComputedRef, watch, nextTick, computed } from 'vue';
import {  voteEdit } from '@/api/vote';



export default /*#__PURE__*/_defineComponent({
  __name: 'foom',
  setup(__props, { expose }) {

const basicStore = useBasicStore();
const { userId, showVoteDialog, roomInfos }= storeToRefs(basicStore);

const voteList= ref({
    userId:userId.value,
    roomNo:roomInfos.value.roomId,
    title:"",
    type:1,
    voteInfo:[{
      choiceType: "radio_type",//radio_type-单选 checkbox_type-多选
      question: "",
      voteAnswers:[{answerItem:""}]
    }]
});

async function parentMsg() {
  console.log("撒-----parentMsg---")
  voteList.value.voteInfo.push({
    choiceType: "radio_type",//radio_type-单选 checkbox_type-多选
    question: "",
    voteAnswers:[{
      answerItem:""
    }]
  })
};

async function  deleteEducation(index : number){
  voteList.value.voteInfo.splice(index, 1)
}

async function voteAdd(k : number){
    console.log(k);
   
  for(let [i,j] of voteList.value.voteInfo.entries()){
    if(k.question==j.question && k.question!=''){
      j.voteAnswers.push({})
    }else if(k.question==''){
      Message({
        type: 'warning',
        message: '请填写题目',
        duration: MESSAGE_DURATION.NORMAL,
      });
    }
    

  }
}
async function deldetlist(item,index){
 
  for(let i of voteList.value.voteInfo){
    if(item.question==i.question){
      i.voteAnswers.splice(index,1)
    }
    
  }
}

async function preserve(){
  voteEdit(
    voteList.value
  ).then(res=>{
    if (res.code == "000"){
      Message({
        type: 'success',
        message: '添加成功',
        duration: MESSAGE_DURATION.NORMAL,
      });
    }else{
      Message({
        type: 'error',
        message: res.msg,
        duration: MESSAGE_DURATION.NORMAL,
      });
    }
  }).catch(err=>{
    console.log(err)
  })
}

//暴露子组件的方法或者数据
expose({
  parentMsg,
  preserve,
})

return { __sfc: true,basicStore, userId, showVoteDialog, roomInfos, voteList, parentMsg, deleteEducation, voteAdd, deldetlist, preserve }
}

})